import { register, findAll, find } from '../../../../Javascript/Utils.js'

const MainNavigation = el => {
  const componentPrefix = 'oHeaderMainNavigation-'
  const componentPrefixSubNav = 'oHeaderSubNavigation-'
  const componentPrefixOpener = 'oHeaderMainNavigation-dropdown-'

  const navItemWithDropdown = findAll(`.${componentPrefix}dropdown`, el)

  const timer = null

  navItemWithDropdown.forEach((opener) => {
    opener.addEventListener('mouseenter', () => {
      // Prevent touch devices from opening the parent page
      // instead of opening the sub navigation
      find('a', opener).addEventListener('click', (e) => {
        e.preventDefault()
      })

      const submenu = find('div', opener)
      clearTimeout(timer)
      opener.classList.add(`${componentPrefixOpener}-open`)
      submenu.classList.add(`${componentPrefixSubNav}-open`)
      submenu.style.left = `-${(submenu.offsetWidth - opener.offsetWidth)}px`
    })

    opener.addEventListener('mouseleave', () => {
      const submenu = find('div', opener)
      opener.classList.remove(`${componentPrefixOpener}-open`)
      submenu.classList.remove(`${componentPrefixSubNav}-open`)
    })
  })
}

register('MainNavigation', MainNavigation)
